module.exports = __webpack_public_path__ + "static/media/HKGroteskPro-SemiBold.8ca08dd9.woff2";